import React from 'react';
import { IconUIComponentProps, useIconStyle } from './Icon';

export default function ({
  color,
  size,
  style,
  className,
  noFill,
}: IconUIComponentProps) {
  const styles = useIconStyle({ noFill });
  return (
    <svg
      className={[styles.icon, className].join(' ').trim()}
      color={color}
      fontSize={size}
      style={style}
      viewBox="0 0 28 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M26.3325 9.51921L3.74141 0.207279C2.78968 -0.185062 1.71453 -0.0124685 0.935452 0.657477C0.156375 1.32753 -0.169453 2.35988 0.0851715 3.35176L2.30515 12L0.0851715 20.6482C-0.169453 21.6401 0.15632 22.6725 0.935397 23.3425C1.71595 24.0139 2.79138 24.1843 3.74141 23.7927L26.3325 14.4808C27.361 14.0568 28 13.1062 28 12C28 10.8938 27.361 9.94317 26.3325 9.51921ZM25.7036 12.9754L3.11261 22.2873C2.7327 22.4439 2.3203 22.3778 2.0093 22.1103C1.69834 21.8429 1.57338 21.4469 1.67499 21.0509L3.78915 12.8149H11.9411C12.3942 12.8149 12.7615 12.45 12.7615 11.9999C12.7615 11.5499 12.3942 11.185 11.9411 11.185H3.78921L1.67499 2.9491C1.57338 2.55318 1.69834 2.15714 2.0093 1.88969C2.32025 1.62225 2.73254 1.55608 3.11256 1.71265L25.7036 11.0246C26.312 11.2753 26.3593 11.8346 26.3593 12C26.3593 12.1654 26.312 12.7246 25.7036 12.9754Z" />
    </svg>
  );
}
